import { FormEvent, useEffect, useState } from "react"
import { iEmpresaDto } from "./dto/nfInterfaces"
import { getUrlSearchParams } from "../urlParams"
import removeAllErrorMsg from "../../components/funcRemoveAllErros"
import { toast } from "react-toastify"
import funcSleep from "../../components/funcSleep"
import { ApiEndpoints, reqGetNew, reqPatch, reqPostNew, reqPut } from "../../config/apiClient"
import LoadingModal from "../../components/loadingModal"
import { Button, Col, Form, Row } from "react-bootstrap"
import NFSeEmpresaCertificadoForm from "./componentes/NFSeEmpresaCertificadoForm"
import $ from 'jquery'
import 'jquery-mask-plugin'
import Select from "react-select"
import { defineValueInInput } from "../../components/funcForInput"

function formatarCnpj(valor:string):string {
    defineValueInInput("cnpj_aux", valor)
    return $("#cnpj_aux").masked(valor)
}

function formatarIss(valor:string):string {
    defineValueInInput("iss_aux", valor)
    return $("#iss_aux").masked(valor)
}

function formatarTelefone(valor:string):string {
    defineValueInInput("telefone_aux", valor)
    return $("#telefone_aux").masked(valor)
}

function NfEmpresasFormPage() {
    const [loading, setLoading] = useState<boolean>(false)
    const [cidade, setCidade] = useState<any>({ "value": "", "label": "Não Selecionado" })
    const [cidadesFiltro, setCidadesFiltro] = useState<any[]>([])
    const [empresaDados, setEmpresaDados] = useState<iEmpresaDto | any>({})
    const [simplesNacionalIss, setSimplesNacionalIss] = useState<number>(2)
    const [showCamposSimplesNacional, setShowCamposSimplesNacional] = useState(false)

    useEffect(() => {
        $('.cnpj').mask('AA.AAA.AAA/AAAA-00', {reverse: false});
        $('.telefone').mask('(00) 00000-0000', {reverse: false});
        $('.porcentagem').mask('000.00', {reverse: true});

        document.title = "Cadastrar NF Empresa | OB PORTUS"

        const urlDados = getUrlSearchParams()
        const id = urlDados.get("id")

        const getDados = async (id:number) => {
            setLoading(true)

            const apiFiltros = await reqGetNew(ApiEndpoints.nfFiltros)

            if (apiFiltros.status === 200) {
                let cidadesAux = apiFiltros.data.nf_cidades.map((item:any, index:any) => (
                    {
                        "value": `${item.cod_cidade}`,
                        "label": `${item.nome}/${item.uf} - Cep ${item.cep}`
                    }
                ))
                setCidadesFiltro(cidadesAux)
            }

            if (id === null || id === 0) {
                setLoading(false)
                return
            }

            const dados = {
                id_empresa: Number(id)
            }

            const api = await reqPostNew(ApiEndpoints.nfEmpresasConsultar, dados)

            if (api.status === 200) {
                const empresa:iEmpresaDto = api.data
                setEmpresaDados(empresa)
                console.log(api.data)
                const cidade = apiFiltros.data.nf_cidades.filter((reg:any) => reg.cod_cidade === api.data.cod_cidade)[0]
                setCidade({
                    "value": `${cidade.cod_cidade}`,
                    "label": `${cidade.nome}/${cidade.uf} - Cep ${cidade.cep}`
                })

                let form:any = document.getElementById("formNfEmpresa")
                form.cnpj.value = formatarCnpj(empresa.cnpj)
                form.razao_social.value = empresa.nome_fantasia
                form.nome.value = empresa.nome
                form.endereco.value = empresa.logradouro
                form.numero.value = empresa.numero
                form.bairro.value = empresa.bairro
                form.complemento.value = empresa.complemento
                form.cep.value = empresa.cep
                form.telefone.value = empresa.telefone
                form.email.value = empresa.email
                form.inscricao_municipal.value = empresa.inscricao_municipal
                if (empresa.inscricao_estadual !== null) {
                    form.inscricao_estadual.value = empresa.inscricao_estadual
                }
                if (empresa.regime_especial_tributacao !== null) {
                    form.regime_especial_tributacao.value = empresa.regime_especial_tributacao
                }
                form.optante_simples_nacional.value = empresa.optante_simples_nacional
                setSimplesNacionalIss(empresa.optante_simples_nacional)
                if (empresa.optante_simples_nacional === 1) {
                    form.iss.value = formatarIss(empresa.ISS!)
                }
                form.incentivo_fiscal.value = empresa.incentivo_fiscal

                form.numero_lote_ah.value = empresa.numero_lote_ah
                form.numero_rps_ah.value = empresa.numero_rps_ah
                form.numero_lote_prod.value = empresa.numero_lote_prod
                form.numero_rps_prod.value = empresa.numero_rps_prod
                form.data_permissao_prefeitura.value = empresa.data_permissao_prefeitura
                form.data_permissao_inicial.value = empresa.data_permissao_inicial
                form.data_permissao_final.value = empresa.data_permissao_final
                form.ambiente.value = empresa.ambiente

                // Campos NFS-e de configurações do Padrão Nacional
                if (form.nfs_situacao_simp_nac) form.nfs_situacao_simp_nac.value = empresa.nfs_situacao_simp_nac ?? ""
                if (empresa.nfs_situacao_simp_nac === 2 || empresa.nfs_situacao_simp_nac === 3) {
                    setShowCamposSimplesNacional(true)
                } else {
                    setShowCamposSimplesNacional(false)
                }
                if (form.nfs_ISS) form.nfs_ISS.value = formatarIss(String(empresa.nfs_ISS)) ?? ""
                if (form.nfs_regime_simp_nac) form.nfs_regime_simp_nac.value = empresa.nfs_regime_simp_nac ?? "0"
                if (form.nfs_regime_especial_trib) form.nfs_regime_especial_trib.value = empresa.nfs_regime_especial_trib ?? ""
                if (form.nfs_num_prod) form.nfs_num_prod.value = empresa.nfs_num_prod ?? ""
                if (form.nfs_lote_prod) form.nfs_lote_prod.value = empresa.nfs_lote_prod ?? ""
                if (form.nfs_dps_prod) form.nfs_dps_prod.value = empresa.nfs_dps_prod ?? ""
                if (form.nfs_num_ah) form.nfs_num_ah.value = empresa.nfs_num_ah ?? ""
                if (form.nfs_lote_ah) form.nfs_lote_ah.value = empresa.nfs_lote_ah ?? ""
                if (form.nfs_dps_ah) form.nfs_dps_ah.value = empresa.nfs_dps_ah ?? ""
                if (form.nfs_tipo_ambiente) form.nfs_tipo_ambiente.value = empresa.nfs_tipo_ambiente ?? ""
                if (form.nfs_ambiente_geracao) form.nfs_ambiente_geracao.value = empresa.nfs_ambiente_geracao ?? ""
                if (form.nfs_tipo_emissao) form.nfs_tipo_emissao.value = empresa.nfs_tipo_emissao ?? ""
                if (form.nfs_processo_emissao) form.nfs_processo_emissao.value = empresa.nfs_processo_emissao ?? ""
                if (form.nfs_tipo_emissor) form.nfs_tipo_emissor.value = empresa.nfs_tipo_emissor ?? ""
                if (form.nfs_versao_aplicacao) form.nfs_versao_aplicacao.value = empresa.nfs_versao_aplicacao ?? ""
                if (form.nfs_total_tributos_federal) form.nfs_total_tributos_federal.value = formatarIss(empresa.nfs_total_tributos_federal) ?? ""
                if (form.nfs_total_tributos_estadual) form.nfs_total_tributos_estadual.value = formatarIss(empresa.nfs_total_tributos_estadual) ?? ""
                if (form.nfs_total_tributos_municipal) form.nfs_total_tributos_municipal.value = formatarIss(empresa.nfs_total_tributos_municipal) ?? ""
                if (form.nfs_total_tributos_simples_nacional) form.nfs_total_tributos_simples_nacional.value = formatarIss(empresa.nfs_total_tributos_simples_nacional) ?? ""
            }

            setLoading(false)
        }

        getDados(Number(id))

        if (id !== null) {
            document.title = "Editar NF Empresa | OB PORTUS"
        }
    }, [])
    async function handleUpdate() {
        setLoading(true)
        const dados = {
            id_empresa: empresaDados.id_empresa
        }
        const api = await reqPostNew(ApiEndpoints.nfEmpresasConsultar, dados)
        if (api.status === 200) {
            setEmpresaDados(api.data)
        }
        setLoading(false)
    }

    // Handler para exibir campos NFS conforme seleção
    function handleNfsSituacaoSimpNacChange(e: any) {
        const value = e.target.value
        setShowCamposSimplesNacional(value === "2" || value === "3")
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()

        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dados:iEmpresaDto = {
            id_empresa: Object.values(empresaDados).length > 0 ? empresaDados?.id_empresa : null,
            cnpj: $("#cnpj").cleanVal(),
            nome: form.nome.value,
            nome_fantasia: form.razao_social.value,
            logradouro: form.endereco.value,
            numero: form.numero.value,
            complemento: form.complemento.value,
            bairro: form.bairro.value,
            cep: form.cep.value,
            cod_cidade: 0,
            cidade: null,
            uf: null,
            telefone: form.telefone.value,
            email: form.email.value,
            inscricao_municipal: form.inscricao_municipal.value,
            inscricao_estadual: form.inscricao_estadual.value === "" ? null : form.inscricao_estadual.value,
            regime_especial_tributacao: Number(form.regime_especial_tributacao.value),
            optante_simples_nacional: Number(form.optante_simples_nacional.value),
            ISS: form.iss.value,
            incentivo_fiscal: form.incentivo_fiscal.value,
            numero_lote_ah: Number(form.numero_lote_ah.value),
            numero_rps_ah: Number(form.numero_rps_ah.value),
            numero_lote_prod: Number(form.numero_lote_prod.value),
            numero_rps_prod: Number(form.numero_rps_prod.value),
            data_permissao_prefeitura: form.data_permissao_prefeitura.value,
            ambiente: form.ambiente.value,
            data_permissao_inicial: form.data_permissao_inicial.value,
            data_permissao_final: form.data_permissao_final.value,
            nfs_situacao_simp_nac: Number(form.nfs_situacao_simp_nac.value),
            nfs_ISS: showCamposSimplesNacional ? form.nfs_ISS.value : null,
            nfs_regime_simp_nac: showCamposSimplesNacional ? Number(form.nfs_regime_simp_nac.value) : null,
            nfs_regime_especial_trib: Number(form.nfs_regime_especial_trib.value),
            nfs_num_prod: Number(form.nfs_num_prod.value),
            nfs_lote_prod: Number(form.nfs_lote_prod.value),
            nfs_dps_prod: Number(form.nfs_dps_prod.value),
            nfs_num_ah: Number(form.nfs_num_ah.value),
            nfs_lote_ah: Number(form.nfs_lote_ah.value),
            nfs_dps_ah: Number(form.nfs_dps_ah.value),
            nfs_tipo_ambiente: Number(form.nfs_tipo_ambiente.value),
            nfs_ambiente_geracao: Number(form.nfs_ambiente_geracao.value),
            nfs_tipo_emissao: Number(form.nfs_tipo_emissao.value),
            nfs_processo_emissao: Number(form.nfs_processo_emissao.value),
            nfs_tipo_emissor: Number(form.nfs_tipo_emissor.value),
            nfs_versao_aplicacao: form.nfs_versao_aplicacao.value,
            nfs_total_tributos_federal: !showCamposSimplesNacional ? form.nfs_total_tributos_federal.value : "0.00",
            nfs_total_tributos_estadual: !showCamposSimplesNacional ? form.nfs_total_tributos_estadual.value : "0.00",
            nfs_total_tributos_municipal: !showCamposSimplesNacional ? form.nfs_total_tributos_municipal.value : "0.00",
            nfs_total_tributos_simples_nacional: showCamposSimplesNacional ? form.nfs_total_tributos_simples_nacional.value : "0.00"
        }
        console.log(form.iss.value)

        if (dados.cnpj === "" || dados.cnpj.length < 14) {
            form.cnpj.nextElementSibling.style.display = "block"
            formValidado = false
        } else { 
            dados.cnpj = String(dados.cnpj).toUpperCase()
        }

        if (dados.nome_fantasia === "") {
            form.razao_social.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.nome === "") {
            form.nome.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.logradouro === "") {
            form.endereco.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.numero === "") {
            form.numero.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.bairro === "") {
            form.bairro.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.complemento === "") {
            dados.complemento = null
        }

        if (dados.cep === "") {
            form.cep.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (Number(cidade.value) === 0) {
            form.cidade_aux.nextElementSibling.style.display = "block"
            formValidado = false
        } else {
            dados.cod_cidade = Number(cidade.value)
        }

        if (dados.telefone === "") {
            form.telefone.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.email === "") {
            form.email.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.telefone === "") {
            form.telefone.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.inscricao_municipal === "") {
            form.inscricao_municipal.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.regime_especial_tributacao === 0) {
            dados.regime_especial_tributacao = null
        }

        if (dados.optante_simples_nacional === 1 && dados.ISS === "") {
            form.iss.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.optante_simples_nacional === 2) {
            dados.ISS = null
        }

        if (dados.numero_lote_ah === 0) {
            form.numero_lote_ah.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.numero_rps_ah === 0) {
            form.numero_rps_ah.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.numero_lote_prod === 0) {
            form.numero_lote_prod.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.numero_rps_prod === 0) {
            form.numero_rps_prod.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.data_permissao_prefeitura === "") {
            form.data_permissao_prefeitura.nextElementSibling.style.display = "block"
            formValidado = false
        }

        if (dados.data_permissao_inicial !== "" || dados.data_permissao_final !== "") {

            if (dados.data_permissao_inicial === "") {
                form.data_permissao_inicial.nextElementSibling.style.display = "block"
                formValidado = false
            }

            if (dados.data_permissao_final === "") {
                form.data_permissao_final.nextElementSibling.style.display = "block"
                formValidado = false
            }

        }

        if (dados.data_permissao_inicial === "") {
            dados.data_permissao_inicial = null
        }

        if (dados.data_permissao_final === "") {
            dados.data_permissao_final = null
        }

        // if (dados.dat === "") {
        //     form.data_permissao_prefeitura.nextElementSibling.style.display = "block"
        //     formValidado = false
        // }

        // Validação dos campos NFS-e (a partir de nfs_situacao_simp_nac)
        if (dados.nfs_situacao_simp_nac === 0) {
            form.nfs_situacao_simp_nac.nextElementSibling.style.display = "block"
            formValidado = false
        }

        // Só valida nfs_ISS e nfs_regime_simp_nac se o campo estiver visível (2 ou 3)
        if (dados.nfs_situacao_simp_nac === 2 || dados.nfs_situacao_simp_nac === 3) {
            if (dados.nfs_ISS === null || dados.nfs_ISS === "" || dados.nfs_ISS === "0") {
                form.nfs_ISS.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (dados.nfs_regime_simp_nac === null || dados.nfs_regime_simp_nac === 0) {
                form.nfs_regime_simp_nac.nextElementSibling.style.display = "block"
                formValidado = false
            }
        }

        if (dados.nfs_regime_especial_trib === null) {
            form.nfs_regime_especial_trib.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_num_prod === null || dados.nfs_num_prod === 0) {
            form.nfs_num_prod.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_lote_prod === null || dados.nfs_lote_prod === 0) {
            form.nfs_lote_prod.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_dps_prod === null || dados.nfs_dps_prod === 0) {
            form.nfs_dps_prod.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_num_ah === null || dados.nfs_num_ah === 0) {
            form.nfs_num_ah.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_lote_ah === null || dados.nfs_lote_ah === 0) {
            form.nfs_lote_ah.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_dps_ah === null || dados.nfs_dps_ah === 0) {
            form.nfs_dps_ah.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_tipo_ambiente === null || dados.nfs_tipo_ambiente === 0) {
            form.nfs_tipo_ambiente.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_ambiente_geracao === null || dados.nfs_ambiente_geracao === 0) {
            form.nfs_ambiente_geracao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_tipo_emissao === null || dados.nfs_tipo_emissao === 0) {
            form.nfs_tipo_emissao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_processo_emissao === null || dados.nfs_processo_emissao === 0) {
            form.nfs_processo_emissao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_tipo_emissor === null || dados.nfs_tipo_emissor === 0) {
            form.nfs_tipo_emissor.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dados.nfs_versao_aplicacao === "") {
            form.nfs_versao_aplicacao.nextElementSibling.style.display = "block"
            formValidado = false
        }

        // Validação dos campos de tributos finais
        if (dados.nfs_situacao_simp_nac === 2 || dados.nfs_situacao_simp_nac === 3) {
            if (dados.nfs_total_tributos_simples_nacional === "" || dados.nfs_total_tributos_simples_nacional === "0") {
                form.nfs_total_tributos_simples_nacional.nextElementSibling.style.display = "block"
                formValidado = false
            }
        } else {
            if (dados.nfs_total_tributos_federal === "" || dados.nfs_total_tributos_federal === "0") {
                form.nfs_total_tributos_federal.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (dados.nfs_total_tributos_estadual === "" || dados.nfs_total_tributos_estadual === "0") {
                form.nfs_total_tributos_estadual.nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (dados.nfs_total_tributos_municipal === "" || dados.nfs_total_tributos_municipal === "0") {
                form.nfs_total_tributos_municipal.nextElementSibling.style.display = "block"
                formValidado = false
            }
        }

        console.info(dados)

        if (!formValidado) {
            return
        }

        if (Object.values(empresaDados).length === 0) {
            cadastrar(dados)
        }

        if (Object.values(empresaDados).length > 0) {
            editar(dados)
        }
    
    }

    async function cadastrar(dados:iEmpresaDto) {

        setLoading(true)

        const api = await reqPut(ApiEndpoints.nfEmpresasCadastrar, dados)

        if (api.status === 201) {
            console.log(api.data)

            toast.success('Empresa cadastrada com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)
            setLoading(false)

            window.location.assign(`/nf/empresas`)
        }
        setLoading(false)

    }

    async function editar(dados: iEmpresaDto) {
        setLoading(true)

        const api = await reqPatch(ApiEndpoints.nfEmpresasEditar, dados)

        setLoading(false)

        if (api.status === 200) {
            console.log(api.data)

            toast.success('Empresa editada com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })

            await funcSleep(500)

            window.location.assign(`/nf/empresas`)
        }
    }

    function handleSimplesNacionalChange(event:any) {
        setSimplesNacionalIss(Number(event.target.value))
    }

    async function handleProcurarCnpj() {

        let cnpj:string = $("#cnpj").cleanVal()
        if (cnpj.length !== 14) {
            toast.warning('Informe um CNPJ válido!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            return
        }

        setLoading(true)

        let link:string = `https://publica.cnpj.ws/cnpj/${cnpj}`

        let apiEmpresaDados:any = null
        let apiDados:Response

        try {
            const options = {method: 'GET', headers: {Accept: 'application/json'}}
            apiDados = await fetch(link, options)
            apiEmpresaDados = await apiDados.json()
            if (apiDados.status === 200) {
                let form:any = document.getElementById("formNfEmpresa")
                form.razao_social.value = apiEmpresaDados.razao_social
                form.nome.value = apiEmpresaDados.estabelecimento.nome_fantasia
                form.endereco.value = apiEmpresaDados.estabelecimento.logradouro
                form.numero.value = apiEmpresaDados.estabelecimento.numero
                form.bairro.value = apiEmpresaDados.estabelecimento.bairro
                form.complemento.value = apiEmpresaDados.estabelecimento.complemento
                form.cep.value = apiEmpresaDados.estabelecimento.cep
                let telefone = `${apiEmpresaDados.estabelecimento.ddd1}${apiEmpresaDados.estabelecimento.telefone1}`
                if (apiEmpresaDados.estabelecimento.ddd1 !== null && apiEmpresaDados.estabelecimento.telefone1 !== null) {
                    form.telefone.value = formatarTelefone(telefone)
                }
                if (apiEmpresaDados.estabelecimento.email !== null) {
                    form.email.value = apiEmpresaDados.estabelecimento.email
                }
                toast.success('Dados encontrado: razao_social, nome_fantasia, logradouro, numero, bairro, complemento, cep, telefone e email. Salve para guardar alterações!', {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark',
                    autoClose: 10000,
                })
            }
        } catch(error) {
            console.log(error)
        }

        console.log(apiEmpresaDados)

        setLoading(false)

    }
    
    return (
        <div id="main">
            <input name='iss_aux' type="text" id='iss_aux' className="porcentagem" style={{display: "none"}} />
            <LoadingModal show={loading} handleClose={(event:any) => {
                setLoading(!loading)
            }} />
            <div className="div-row-space-between">
            <h1 id="titleMain">NF Empresa</h1>
            <Button variant="secondary" onClick={() => {window.location.assign(`/nf/empresas`)}}>Voltar</Button>
            </div>
            <br></br>
            <Form id='formNfEmpresa' onSubmit={handleSubmit} noValidate>
            <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>CNPJ:</Form.Label>
                            <Form.Control name='cnpj' type="text" id='cnpj' className="cnpj" placeholder="00.000.000/0000-00"/>
                            <Form.Control.Feedback type="invalid">
                                Informe o CNPJ!
                            </Form.Control.Feedback>
                            <input name='cnpj_aux' type="text" id='cnpj_aux' className="cnpj" style={{display: "none"}} />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group>
                            <Form.Label>Procurar CNPJ?</Form.Label><br></br>
                            <Button onClick={() => {handleProcurarCnpj()}}>Pesquisar</Button>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Razão Social:</Form.Label>
                            <Form.Control name='razao_social' type="text" id='razao_social' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe a Razão Social!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Nome:</Form.Label>
                            <Form.Control name='nome' type="text" id='nome' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe o Nome!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-4">
                        <Form.Group>
                            <Form.Label>Endereço:</Form.Label>
                            <Form.Control name='endereco' type="text" id='endereco' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe o Endereço!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-1">
                        <Form.Group>
                            <Form.Label>Número:</Form.Label>
                            <Form.Control name='numero' type="text" id='numero' placeholder="0"/>
                            <Form.Control.Feedback type="invalid">
                                Informe o Número!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-1">
                        <Form.Group>
                            <Form.Label>Bairro:</Form.Label>
                            <Form.Control name='bairro' type="text" id='bairro' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe o Bairro!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Cidade:</Form.Label>
                            <Select name='cidade' id='cidade' options={cidadesFiltro} value={cidade} placeholder="Selecione a cidade" onChange={
                                    (choice:any) => {
                                        setCidade(choice)
                                    }
                                } styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: "#dee2e6"
                                    }),
                                }} />
                            </Form.Group>
                            <Form.Control name='cidade_aux' type="text" id='cidade_aux' placeholder="" style={{display: "none"}}/>
                            <Form.Control.Feedback type="invalid">
                                Informe a Cidade!
                            </Form.Control.Feedback>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Complemento:</Form.Label>
                            <Form.Control name='complemento' type="text" id='complemento' placeholder=""/>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>CEP:</Form.Label>
                            <Form.Control name='cep' type="text" id='cep' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe o CEP!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Telefone:</Form.Label>
                            <Form.Control name='telefone' type="text" id='telefone' placeholder="(00) 00000-0000" className="telefone" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Telefone!
                            </Form.Control.Feedback>
                            <Form.Control name='telefone_aux' type="text" id='telefone_aux' className="telefone" style={{display: 'none'}} />
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>E-mail:</Form.Label>
                            <Form.Control name='email' type="email" id='email' placeholder=""/>
                            <Form.Control.Feedback type="invalid">
                                Informe o E-mail!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Inscrição Municipal:</Form.Label>
                            <Form.Control name='inscricao_municipal' type="number" id='inscricao_municipal' placeholder="0"/>
                            <Form.Control.Feedback type="invalid">
                                Informe a Inscrição Municipal!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Inscrição Estadual:</Form.Label>
                            <Form.Control name='inscricao_estadual' type="number" id='inscricao_estadual' placeholder="0"/>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Regime Especial Tributação:</Form.Label>
                            <Form.Select name="regime_especial_tributacao" id="regime_especial_tributacao" aria-label="">
                                <option value="0">Não Informar</option>
                                <option value="1">Microempresa Municipal</option>
                                <option value="2">Estimativa</option>
                                <option value="3">Sociedade de Profissionais</option>
                                <option value="4">Cooperativa</option>
                                <option value="5">Microempresário Individual (MEI)</option>
                                <option value="6">Microempresa ou Empresa de Pequeno Porte (ME EPP)</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Optante Simples Nacional:</Form.Label>
                            <Form.Select name="optante_simples_nacional" id="optante_simples_nacional" onChange={handleSimplesNacionalChange} aria-label="">
                                <option value="2">Não</option>
                                <option value="1">Sim</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3" style={{display: simplesNacionalIss === 1 ? 'block' : 'none'}}>
                        <Form.Group>
                            <Form.Label>ISS (%):</Form.Label>
                            <Form.Control name='iss' type="text" id='iss' placeholder="0.00 %" className="porcentagem"/>
                            <Form.Control.Feedback type="invalid">
                                Informe o ISS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Incentivo Fiscal:</Form.Label>
                            <Form.Select name="incentivo_fiscal" id="incentivo_fiscal" aria-label="">
                                <option value="2">Não</option>
                                <option value="1">Sim</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Número LOTE (HOMOLOGAÇÃO):</Form.Label>
                            <Form.Control name='numero_lote_ah' type="number" id='numero_lote_ah' placeholder="0" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Número LOTE (HOMOLOGAÇÃO)!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Número RPS (HOMOLOGAÇÃO):</Form.Label>
                            <Form.Control name='numero_rps_ah' type="number" id='numero_rps_ah' placeholder="0" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Número RPS (HOMOLOGAÇÃO)!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Número LOTE (PRODUÇÃO):</Form.Label>
                            <Form.Control name='numero_lote_prod' type="number" id='numero_lote_prod' placeholder="0" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Número LOTE (HOMOLOGAÇÃO)!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Número RPS (PRODUÇÃO):</Form.Label>
                            <Form.Control name='numero_rps_prod' type="number" id='numero_rps_prod' placeholder="0" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Número RPS (PRODUÇÃO)!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Ambiente Atual:</Form.Label>
                            <Form.Select name="ambiente" id="ambiente" aria-label="">
                                <option value="ah">HOMOLOGAÇÃO</option>
                                <option value="prod">PRODUÇÃO</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Data da ultima solicitação de permissão prefeitura:</Form.Label>
                            <Form.Control name='data_permissao_prefeitura' type="date" id='data_permissao_prefeitura' />
                            <Form.Control.Feedback type="invalid">
                                Informe a data em que foi solicitado a ultima permissão na prefeitura!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Dt. Inicial p/ Impressão:</Form.Label>
                            <Form.Control name='data_permissao_inicial' type="date" id='data_permissao_inicial' />
                            <Form.Control.Feedback type="invalid">
                                Informe a data inicial!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Dt. Final p/ Impressão:</Form.Label>
                            <Form.Control name='data_permissao_final' type="date" id='data_permissao_final' />
                            <Form.Control.Feedback type="invalid">
                                Informe a data final!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <hr></hr>
                <h2 id="titleMain">NFSe Configurações - Padrão Nacional</h2>
                <br></br>

                <Row className="mb-15-forms"> {/* Campos de Seleção relacionados os SIMPLES NACIONAL da NFS */}
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>NFS Situação Simples Nacional</Form.Label>
                            <Form.Select name="nfs_situacao_simp_nac" id="nfs_situacao_simp_nac" aria-label="" onChange={handleNfsSituacaoSimpNacChange} defaultValue={empresaDados?.nfs_situacao_simp_nac ?? "0"}>
                                <option value="0">Não informado</option>
                                <option value="1">1 - Não Optante</option>
                                <option value="2">2 - Optante - Microempreendedor Individual (MEI)</option>
                                <option value="3">3 - Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    {showCamposSimplesNacional && (
                        <>
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>NFS ISS (%)</Form.Label>
                                <Form.Control name='nfs_ISS' type="text" id='nfs_ISS' placeholder="0.00 %" className="porcentagem" defaultValue={Object.values(empresaDados).length === 0 ? "0.00" : formatarIss(empresaDados.nfs_ISS)} />
                                <Form.Control.Feedback type="invalid">
                                    Informe o valor do ISS!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>NFS Regime Simples Nacional</Form.Label>
                                <Form.Select name="nfs_regime_simp_nac" id="nfs_regime_simp_nac" aria-label="" defaultValue={Object.values(empresaDados).length === 0 ? "0.00" : String(empresaDados.nfs_regime_simp_nac)}>
                                    <option value="0">Não informado</option>
                                    <option value="1">1 - Regime de apuração dos tributos federais e municipal pelo SN</option>
                                    <option value="2">2 - Regime de apuração dos tributos federais pelo SN e o ISSQN pela NFS-e conforme respectiva legislação municipal do tributo</option>
                                    <option value="3">3 - Regime de apuração dos tributos federais e municipal pela NFS-e conforme respectivas legislações federal e municipal de cada tributo</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Selecione a opção!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        </>
                    )}
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>NFS Regime Especial Tributação</Form.Label>
                            <Form.Select name="nfs_regime_especial_trib" id="nfs_regime_especial_trib" aria-label="">
                                <option value="0">0 - Nenhum</option>
                                <option value="1">1 - Ato Cooperado (Cooperativa)</option>
                                <option value="2">2 - Estimativa</option>
                                <option value="3">3 - Microempresa Municipal</option>
                                <option value="4">4 - Notário ou Registrador</option>
                                <option value="5">5 - Profissional Autônomo</option>
                                <option value="6">6 - Sociedade de Profissionais</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-15-forms"> {/* Campos Numéricos relacionados com a NFS */}
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Num Prod</Form.Label>
                            <Form.Control name='nfs_num_prod' type="number" id='nfs_num_prod' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o número da NFS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Lote Prod</Form.Label>
                            <Form.Control name='nfs_lote_prod' type="number" id='nfs_lote_prod' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o lote da NFS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS DPS Prod</Form.Label>
                            <Form.Control name='nfs_dps_prod' type="number" id='nfs_dps_prod' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o DPS da NFS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Num AH</Form.Label>
                            <Form.Control name='nfs_num_ah' type="number" id='nfs_num_ah' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o número da NFS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Lote AH</Form.Label>
                            <Form.Control name='nfs_lote_ah' type="number" id='nfs_lote_ah' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o lote da NFS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS DPS AH</Form.Label>
                            <Form.Control name='nfs_dps_ah' type="number" id='nfs_dps_ah' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o DPS da NFS!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-15-forms"> {/* Campos de Seleção relacionados com a NFS */}
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Tipo Ambiente</Form.Label>
                            <Form.Select name="nfs_tipo_ambiente" id="nfs_tipo_ambiente" aria-label="">
                                <option value="0">Não informado</option>
                                <option value="1">1 - Produção</option>
                                <option value="2">2 - Homologação</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Ambiente Geração</Form.Label>
                            <Form.Select name="nfs_ambiente_geracao" id="nfs_ambiente_geracao" aria-label="">
                                <option value="0">Não informado</option>
                                <option value="1">1 - Sistema Próprio do Município</option>
                                <option value="2">2 - Sefin Nacional NFS-e</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Tipo Emissão</Form.Label>
                            <Form.Select name="nfs_tipo_emissao" id="nfs_tipo_emissao" aria-label="">
                                <option value="0">Não informado</option>
                                <option value="1">1 - Emissão normal no modelo da NFS-e Nacional</option>
                                <option value="2">2 - Emissão original em leiaute próprio do município com transcrição para o modelo da NFS-e Nacional</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Processo Emissão</Form.Label>
                            <Form.Select name="nfs_processo_emissao" id="nfs_processo_emissao" aria-label="">
                                <option value="0">Não informado</option>
                                <option value="1">1 - Emissão com aplicativo do contribuinte (via Web Service)</option>
                                <option value="2">2 - Emissão com aplicativo disponibilizado pelo fisco (Web)</option>
                                <option value="3">3 - Emissão com aplicativo disponibilizado pelo fisco (App)</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Tipo Emissor</Form.Label>
                            <Form.Select name="nfs_tipo_emissor" id="nfs_tipo_emissor" aria-label="">
                                <option value="0">Não informado</option>
                                <option value="1">1 - Prestador</option>
                                <option value="2">2 - Tomador</option>
                                <option value="3">3 - Intermediário</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>NFS Versão Aplicação</Form.Label>
                            <Form.Control name='nfs_versao_aplicacao' type="text" id='nfs_versao_aplicacao' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Selecione uma opção!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mb-15-forms"> {/* Campos Porcentagem Total relacionados com a NFS */}
                    {!showCamposSimplesNacional &&
                        <>
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>NFS Total Tributos Federal (%)</Form.Label>
                                <Form.Control name='nfs_total_tributos_federal' type="text" id='nfs_total_tributos_federal' placeholder="0.00 %" className="porcentagem" defaultValue={Object.values(empresaDados).length === 0 ? "0" : formatarIss(empresaDados.nfs_total_tributos_federal)} />
                                <Form.Control.Feedback type="invalid">
                                    Selecione uma opção!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>NFS Total Tributos Estadual (%)</Form.Label>
                                <Form.Control name='nfs_total_tributos_estadual' type="text" id='nfs_total_tributos_estadual' placeholder="0.00 %" className="porcentagem" defaultValue={Object.values(empresaDados).length === 0 ? "0" : formatarIss(empresaDados.nfs_total_tributos_estadual)} />
                                <Form.Control.Feedback type="invalid">
                                    Selecione uma opção!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>NFS Total Tributos Municipal (%)</Form.Label>
                                <Form.Control name='nfs_total_tributos_municipal' type="text" id='nfs_total_tributos_municipal' placeholder="0.00 %" className="porcentagem" defaultValue={Object.values(empresaDados).length === 0 ? "0" : formatarIss(empresaDados.nfs_total_tributos_municipal)} />
                                <Form.Control.Feedback type="invalid">
                                    Selecione uma opção!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        </>
                    }
                    {
                        showCamposSimplesNacional &&
                        <Col className="col-3">
                            <Form.Group>
                                <Form.Label>NFS Total Tributos Simples Nacional (%)</Form.Label>
                                <Form.Control name='nfs_total_tributos_simples_nacional' type="text" id='nfs_total_tributos_simples_nacional' placeholder="0.00 %" className="porcentagem" defaultValue={Object.values(empresaDados).length === 0 ? "0" : formatarIss(empresaDados.nfs_total_tributos_simples_nacional)} />
                                <Form.Control.Feedback type="invalid">
                                    Selecione uma opção!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    }
                </Row>

                {
                    Object.values(empresaDados).length === 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Cadastrar'}</Button>
                }

                {
                    Object.values(empresaDados).length > 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Editar'}</Button>
                }
            </Form>

            <br></br>
            <br></br>
            <br></br>
            {/* Formulário de upload de arquivo PFX */}
            <NFSeEmpresaCertificadoForm empresa={empresaDados} handleUpdate={handleUpdate} />
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
        </div>
    )
}

export default NfEmpresasFormPage
